import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "code-block-64", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor", strokeWidth: 1.2 },
        React.createElement("path", { d: "M5.5 9.5l-2-2 2-2m7.5 4l2-2-2-2M10 4l-1.5 7h0L10 4" }),
        React.createElement("path", { strokeOpacity: 0.3, d: "M18.254 6.25a2 2 0 012 2v8a2 2 0 01-2 2H6.75a2 2 0 01-2-2V13.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
